import { useTranslation } from 'next-i18next'
import styles from './PageInfo.module.scss'
import React from 'react'

type Props = {
  languageCode?: string,
  children: React.ReactNode
}

const PageInfo = (props: Props) => {
  const { i18n } = useTranslation()

  if (props.languageCode && i18n.language !== props.languageCode.toLowerCase()) {
    return null
  }

  return (
    <div className={styles.component}>
      {props.children}
    </div>
  )
}

export default PageInfo